import type { ReactElement } from 'react';

import DentistSearch from '../../components/DentistSearch';

export default function LandPage(): ReactElement {
  return <DentistSearch variant="standalone" includeAllSpecialties />;
}
